export const shiftClaimRouts = {
  ShiftClaim: {
    screens: {
      // URL pattern: /claim-shift?sct=<token>&runId=<id>&shiftId=<id>
      ShiftClaimScreen: 'claim-shift',
    },
  },
};
